import { render, staticRenderFns } from "./UknowAdmins.vue?vue&type=template&id=cef6d14c&scoped=true&"
import script from "./UknowAdmins.vue?vue&type=script&lang=ts&"
export * from "./UknowAdmins.vue?vue&type=script&lang=ts&"
import style0 from "./UknowAdmins.vue?vue&type=style&index=0&id=cef6d14c&lang=scss&scoped=true&"
import style1 from "./UknowAdmins.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef6d14c",
  null
  
)

export default component.exports